// extracted by mini-css-extract-plugin
export var pager = "index-module--pager--zNxg6";